import * as React from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';

export function textLineWithColor(color: TypographyProps['color']): ((value: string, index: number) => React.ReactNode) {
    return (value: string, index: number) => {
        return <Typography variant="body2" color={color} key={index}>{value}</Typography>;
    };
}

export function textLine(value: string, index: number): React.ReactNode {
    return <Typography variant="body2" key={index}>{value}</Typography>;
}